import 'dayjs/locale/pl'
import { Dayjs } from 'dayjs'

const pl = {
  calendar: {
    sameDay: '[Dziś o] LT',
    nextDay: '[Jutro o] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[W niedzielę o] LT')

        case 2:
          return now.format('[We wtorek o] LT')

        case 3:
          return now.format('[W środę o] LT')

        case 6:
          return now.format('[W sobotę o] LT')

        default:
          return now.format('[W] dddd [o] LT')
      }
    },
    lastDay: '[Wczoraj o] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[W zeszłą niedzielę o] LT')
        case 3:
          return now.format('[W zeszłą środę o] LT')
        case 6:
          return now.format('[W zeszłą sobotę o] LT')
        default:
          return now.format('[W zeszły] dddd [o] LT')
      }
    },
    sameElse: 'L'
  }
}

export default pl
